import {useQuery} from 'react-query'
import api from '../api'
import {params} from '../commonTypes'

export const useGetSoldoutDaysQuery = ({from, to, sessions}: params.GetReport) => {
  return useQuery(['getSoldoutDays', from, to, sessions], () => api.getSoldoutDays({from, to, sessions}))
}
